export enum WorkAgreementField {
  ClientTeam = 'ClientTeam',
  VendorTeam = 'VendorTeam',
  Policies = 'Policies',
  Conflicts = 'Conflicts',
  FeeSchedule = 'FeeSchedule',
  Currency = 'Currency',
  Discount = 'Discount',
  Invoices = 'Invoices'
}
